<div class="tpiq-input-search" id="{{id}}" (clickOutside)="hideDropdown()">

  <div [ngClass]="{'active-dropdown': displayDropdown}" class="dropdown-div pointer"
       style="padding: 0;">
    <i class="icon ion-arrow-down-b" (click)="showAllEntries()" style="margin-bottom: 4px;"></i>
    <input type="text" style="font-size: .95em !important;" (click)="showAllEntries()" (keydown.ArrowDown)="highlightNext($event)" (keydown.ArrowUp)="highlightPrevious($event)"
           (keydown.Enter)="selectEntry($event)" (keydown.Tab)="onTabPress($event)" (keydown.shift.Tab)="hideDropdown()"
           (keydown.esc)="hideDropdown()" (keyup)="filterEntries($event)" value="{{entry}}" placeholder="{{placeHolder}}"
           [ngClass]="{'placehol der': !entry, 'value': entry}" [disabled]="disabled" (blur)="isOnBlur ? onBlur($event) : null"/>
  </div>

  <ul *ngIf="displayDropdown" class="dropdown ui-menu">
    <li (click)="triggerOnSelectNone()" *ngIf="displayNone" class="pointer">
      {{noneLabel}}
    </li>
    <li *ngFor="let entry of filteredEntries;let idx=index;" (click)="triggerOnSelect($event, entry)" (mouseover)="highlightAtIndex(idx)"
        [ngClass]="{'highlight-option': highlightIndex == idx}" class="pointer">
      {{entry[searchKey]}}
    </li>
  </ul>
</div>


